import React from "react";
import { Link } from "react-router-dom";
import { convertToUTCFormat } from "../utils/format";
import {
  getActionDiv,
  getTableStyles,
  getTimeLapsedDiv,
  openReasonModal,
} from "../utils/bankbox";
import { format } from "date-fns";
import { getSortingClass } from "../utils/table";
import PaginationButtons from "./PaginationButtons";

const BankboxTable = ({
  activeTab,
  page,
  tabData,
  sortingColumns,
  handleSorting,
  fetchListData,
  prevPage,
  nextPage,
  pageSelected,
  bankBoxPanelState,
  setBankBoxPanelState,
}) => {
  return (
    <div role="tabpanel" className="tab-pane fade in active" id="open_cases">
      <div className="table-responsive">
        <div id="case_wrapper" className="dataTables_wrapper no-footer">
          <table
            id="bxOpenCase"
            className="fmTableview display table table-bordered table-hover dataTable"
            cellSpacing="0"
            width="100%"
          >
            <style>{getTableStyles(activeTab)}</style>
            <thead>
              <tr>
                <th
                  className={`sorting${getSortingClass(
                    sortingColumns,
                    "lead_id",
                  )} bankboxlist-lead-id`}
                  onClick={() => handleSorting("lead_id")}
                >
                  Loan ID
                </th>
                <th className="sorting_disabled bankboxlist-tranche">
                  Tranche #
                </th>
                <th
                  className={
                    [1, 4].includes(activeTab)
                      ? `sorting${getSortingClass(
                          sortingColumns,
                          "payment_amount",
                        )} bankboxlist-payment-amount`
                      : "sorting_disabled bankboxlist-payment-amount"
                  }
                  onClick={() =>
                    [1, 4].includes(activeTab)
                      ? handleSorting("payment_amount")
                      : {}
                  }
                >
                  Payment Amount
                </th>
                <th
                  className={
                    [1, 4].includes(activeTab)
                      ? `sorting${getSortingClass(
                          sortingColumns,
                          "request_date",
                        )} bankboxlist-request-date`
                      : "sorting_disabled bankboxlist-request-date"
                  }
                  onClick={() =>
                    [1, 4].includes(activeTab)
                      ? handleSorting("request_date")
                      : {}
                  }
                >
                  Request Date
                </th>
                {activeTab !== 1 ? (
                  <th className="sorting_disabled bankboxlist-bank">Bank</th>
                ) : (
                  ""
                )}

                {activeTab === 0 ? (
                  <th className="sorting_disabled bankboxlist-time-lapsed">
                    Time Lapsed
                  </th>
                ) : (
                  ""
                )}

                {activeTab === 2 ? (
                  <>
                    <th className="sorting_disabled bankboxlist-hold-by">
                      Hold By
                    </th>
                    <th className="sorting_disabled bankboxlist-hold-time">
                      Hold Time
                    </th>
                    <th className="sorting_disabled bankboxlist-reason">
                      Reason
                    </th>
                  </>
                ) : (
                  ""
                )}

                {activeTab === 3 ? (
                  <th className="sorting_disabled bankboxlist-completed-time">
                    Completed Time
                  </th>
                ) : (
                  ""
                )}

                {activeTab === 6 ? (
                  <th
                    className={
                      [6].includes(activeTab)
                        ? `sorting${getSortingClass(
                            sortingColumns,
                            "bank_reversed_txn_date",
                          )} bankboxlist-bank-reversed-txn-date`
                        : "sorting_disabled bankboxlist-reversed-time"
                    }
                    onClick={() =>
                      [6].includes(activeTab)
                        ? handleSorting("bank_reversed_txn_date")
                        : {}
                    }
                  >
                    Reversed Txn Time
                  </th>
                ) : (
                  ""
                )}

                {activeTab === 4 ? (
                  <th className="sorting_disabled bankboxlist-cancelled-by">
                    Cancelled by
                  </th>
                ) : (
                  ""
                )}

                {activeTab === 5 ? (
                  <th className="sorting_disabled bankboxlist-hold-cancelled-failed-time">
                    Hold/ Cancelled/ Failed/ Completed Time
                  </th>
                ) : (
                  ""
                )}

                <th
                  className={
                    [3, 4, 5].includes(activeTab)
                      ? `sorting${getSortingClass(
                          sortingColumns,
                          "status",
                        )} bankboxlist-status`
                      : "sorting_disabled bankboxlist-status"
                  }
                  onClick={() =>
                    [3, 4, 5].includes(activeTab) ? handleSorting("status") : {}
                  }
                >
                  Status
                </th>

                {activeTab === 4 ? (
                  <th
                    className={`sorting${getSortingClass(
                      sortingColumns,
                      "cancelled_time",
                    )} bankboxlist-cancelled-time`}
                    onClick={() => handleSorting("cancelled_time")}
                  >
                    Cancelled/failed Time
                  </th>
                ) : (
                  ""
                )}

                {[1, 3, 5].includes(activeTab) ? (
                  <th
                    className={
                      [3, 5].includes(activeTab)
                        ? `sorting${getSortingClass(
                            sortingColumns,
                            "bank_status",
                          )} bankboxlist-bank-status`
                        : "sorting_disabled bankboxlist-bank-status"
                    }
                    onClick={() =>
                      [3, 5].includes(activeTab)
                        ? handleSorting("bank_status")
                        : {}
                    }
                  >
                    Bank Status
                  </th>
                ) : (
                  ""
                )}

                {[4, 5].includes(activeTab) ? (
                  <th className="sorting_disabled bankboxlist-reason">
                    Reason
                  </th>
                ) : (
                  ""
                )}

                {activeTab !== 5 ? (
                  <th className="sorting_disabled bankboxlist-action">
                    Action
                  </th>
                ) : (
                  ""
                )}
              </tr>
            </thead>
            <tbody>
              {!tabData.caseData.length ? (
                <tr className="odd">
                  <td valign="top" colSpan="14" className="dataTables_empty">
                    No data available in table
                  </td>
                </tr>
              ) : (
                ""
              )}
              {tabData.caseData.map((caseObj, idx) => {
                const {
                  finance_lead_id,
                  pay_count,
                  payment_amount,
                  payment_req_date,
                  default_execution_time,
                  payable_ac_number,
                  bank_txn_status_name,
                  bank_txn_status,
                  bank_status,
                  next_executeion_time,
                  bank_reversed_txn_status,
                  bank_reversed_txn_date,
                  queue_status,
                  created,
                  txn_user_name,
                  payment_update_date,
                  reason,
                  txn_id,
                  trancheID,
                } = caseObj;

                const { timeLapsedDiv, showBtn } = getTimeLapsedDiv(
                  payment_req_date,
                  default_execution_time,
                );

                const actionDiv = getActionDiv(
                  bank_txn_status,
                  next_executeion_time,
                  queue_status,
                  created,
                  txn_id,
                  trancheID,
                  activeTab,
                  bankBoxPanelState,
                  setBankBoxPanelState,
                  fetchListData,
                );

                const paymentStatusDate = payment_update_date
                  ? convertToUTCFormat(
                      new Date(payment_update_date),
                      "dd MMM, yyyy hh:mm a",
                    )
                  : "--";
                const bankReversedTxnDate = bank_reversed_txn_date
                  ? convertToUTCFormat(
                      new Date(bank_reversed_txn_date),
                      "dd MMM, yyyy hh:mm a",
                    )
                  : "--";

                return (
                  <tr
                    role="row"
                    className={`${
                      idx % 2 === 1 ? "even" : "odd"
                    } withheld-table-row`}
                    key={idx}
                  >
                    <td className="sorting_1">
                      <Link
                        to={`/payments/details?lead_id=${btoa(
                          finance_lead_id,
                        )}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="withheld-panel-lead-id"
                      >
                        {finance_lead_id}
                      </Link>
                    </td>
                    <td>{pay_count}</td>
                    <td>
                      <div className="clearfix font-12 col-black line-hit-24">
                        {payment_amount ? (
                          <>
                            <i className="fa fa-inr"></i>
                            {payment_amount}
                          </>
                        ) : (
                          "--"
                        )}
                      </div>
                    </td>
                    <td>
                      {payment_req_date
                        ? convertToUTCFormat(
                            new Date(payment_req_date),
                            "dd MMM, yyyy hh:mm a",
                          )
                        : "--"}
                    </td>
                    {activeTab !== 1 ? <td>{payable_ac_number}</td> : ""}
                    {activeTab === 0 ? <td>{timeLapsedDiv}</td> : ""}

                    {activeTab === 2 ? (
                      <>
                        <td>{txn_user_name}</td>
                        <td>{paymentStatusDate}</td>
                        <td>{reason}</td>
                      </>
                    ) : (
                      ""
                    )}

                    {activeTab === 3 ? <td>{paymentStatusDate}</td> : ""}

                    {activeTab === 6 ? <td>{bankReversedTxnDate}</td> : ""}

                    {activeTab === 4 ? <td>{txn_user_name}</td> : ""}

                    {activeTab === 5 ? <td>{paymentStatusDate}</td> : ""}

                    <td>{bank_txn_status_name}</td>
                    {activeTab === 4 ? <td>{paymentStatusDate}</td> : ""}

                    {[1, 3, 5].includes(activeTab) ? (
                      <td>{bank_status ? bank_status : "--"}</td>
                    ) : (
                      ""
                    )}

                    {[4, 5].includes(activeTab) ? <td>{reason}</td> : ""}

                    {(() => {
                      if (activeTab === 0) {
                        return (
                          <td>
                            {+bank_txn_status === 1 && showBtn ? (
                              <div className="btn-group holdbtn">
                                <button
                                  className="btn btn-sm btn-primary mrg-all-0 bankbox-hold-btn"
                                  onClick={(e) =>
                                    openReasonModal(
                                      trancheID,
                                      "hold",
                                      bankBoxPanelState,
                                      setBankBoxPanelState,
                                      e,
                                    )
                                  }
                                  disabled={
                                    bankBoxPanelState.manualActionBtnDisabled[
                                      txn_id
                                    ]
                                  }
                                >
                                  Hold
                                </button>
                              </div>
                            ) : (
                              "--"
                            )}
                          </td>
                        );
                      } else if (activeTab !== 5) {
                        return <td>{actionDiv}</td>;
                      }
                    })()}
                  </tr>
                );
              })}
            </tbody>
          </table>
          <PaginationButtons
            page={page}
            total={tabData.total}
            prevPage={prevPage}
            nextPage={nextPage}
            pageSelected={pageSelected}
          />
        </div>
      </div>
    </div>
  );
};

export default BankboxTable;
